import { makeStyles, createStyles } from '@material-ui/core/styles';

const CONTENT_WIDTH = 1200;

const brandStyles = {
  forreston: {
    logo: {
      top: '18%',
      right: 0,
      height: '68vh'
    }
  },
  cfm: {
    logo: {
      left: 0,
      height: '100vh'
    }
  }
};

const styles = (theme) =>
  createStyles({
    // Flex-grows to fill the space left in the #root column below the header,
    // rather than a fixed calc(100vh - headerHeight). This keeps the scroll
    // container's bottom on-screen when a body-level banner (Appcues) is shown. (#30714)
    layout: {
      position: 'relative',
      // Keeps the gutter art's negative z-index inside the page, behind its content.
      isolation: ({ showArtwork }) => (showArtwork ? 'isolate' : undefined),
      width: '100%',
      left: 0,
      transition: '225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
      flex: '1 1 auto',
      minHeight: 0,
      'overflow-y': 'auto'
    },
    // Fixed behind the page and sized to the gutters beside the 1200px column; hidden on narrower screens, where
    // there's no room for it. It ends above any [data-gutter-footer] bar (see use-gutter-floor).
    gutterArtwork: {
      display: 'none',
      pointerEvents: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: ({ footerHeight }) => footerHeight,
      zIndex: -1,
      overflow: 'hidden',
      '@media (min-width: 1800px) and (min-height: 700px)': { display: 'block' },
      '@media print': { display: 'none' },
      '& > svg': {
        position: 'absolute',
        bottom: 0,
        height: 'auto',
        maxHeight: `calc(100% - ${theme.sizes.headerHeight + theme.spacing(12)}px)`,
        userSelect: 'none'
      }
    },
    leftArtwork: {
      left: 0,
      width: `min(420px, calc((100% - ${CONTENT_WIDTH}px) / 2 - ${theme.spacing(6)}px))`
    },
    rightArtwork: {
      // Leaves the outer rail for the Help and tour buttons.
      right: theme.spacing(28),
      width: `min(300px, calc((100% - ${CONTENT_WIDTH}px) / 2 - ${theme.spacing(34)}px))`
    },
    loading: {
      display: 'flex',
      paddingTop: 0,
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: ({ showHeader, isCdComparison }) => ({
      width: CONTENT_WIDTH,
      maxWidth: isCdComparison ? `calc(100% - ${theme.spacing(8)}px)` : undefined,
      height: showHeader ? 'auto' : '100vh',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: showHeader ? theme.spacing(10) : 0
    }),
    logo: ({ brand }) => ({
      position: 'absolute',
      top: 0,
      right: 0,
      height: '100vh',
      ...(brandStyles[brand]?.logo || {})
    })
  });

export default makeStyles(styles);
